import { memo, useContext } from "react";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import CustomFormattedMessageContainer from "app/pages/.shared/CustomFormattedMessage/CustomFormattedMessageContainer";
import InfoPopover from "app/components/ui/InfoPopover/InfoPopover";
import PaymentModesTooltipContainer from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentModes/PaymentModesTooltipContainer";
import "./PaymentDescription.scss";
import PropTypes from "prop-types";
import { useFsFlag } from "@flagship.io/react-sdk";
import { BRANDS } from "app/constants";
import AppGlobalsContext from "app/AppGlobalsContext";

const PaymentDescription = ({ availablePaymentMethods = [], message }) => {
	const { brand } = useContext(AppGlobalsContext);
	const isBrandTO = brand === BRANDS.TO;
	const showDepositFlag = useFsFlag("show_deposit_payment_terms");
	const showDepositFlagValue = showDepositFlag.getValue(true);

	const variationMessage = showDepositFlagValue
		? "Nouveau ! Réservez votre voyage en payant un acompte de seulement {depositPercentage}"
		: "Échelonnez votre paiement, payez en {paymentTerms}";

	return (
		<div className="payment-description">
			<Typography
				variant={TYPOGRAPHY_VARIANTS.LARGE}
				variantMD={TYPOGRAPHY_VARIANTS.XL2}
				isBold
				className="payment-description__content"
			>
				<CustomFormattedMessageContainer
					message={isBrandTO ? variationMessage : message}
					className="payment-description__terms"
					children={
						<InfoPopover iconSize={16}>
							<PaymentModesTooltipContainer paymentModes={availablePaymentMethods} />
						</InfoPopover>
					}
					enableHTMLFormatting={true}
				/>
			</Typography>
		</div>
	);
};
PaymentDescription.propTypes = {
	availablePaymentMethods: PropTypes.array,
	message: PropTypes.string,
};

export default memo(PaymentDescription);
